module.exports = __webpack_public_path__ + "img/MeetingNavigator-iPad.e308589c.jpg";